import HubServices from "../../configuration/config.json"
import Vue from 'vue';
import axios from 'axios';
// import VueAlertify from 'vue-alertify';
// Vue.use(VueAlertify);

export default function gettingRestClientObject() {
    var myObject = new Vue({
        methods: {
            pluck: function (key, contentArry) {
                var Temparry = [];
                contentArry.map(function (item) {
                    if (item[key] != undefined) {
                        Temparry.push(item[key]);
                    }
                });
                return Temparry;
            },
            pluckcom: function (key, contentArry) {
                var Temparry = [];
                contentArry.map(function (item) {
                    if (item[key] != undefined) {
                        Temparry = item[key];
                    }
                });
                return Temparry;
            },
            getAllMapData: function (contentArry) {
                var tempDataObject = {};
                if (contentArry != undefined) {
                    contentArry.map(function (item) {
                        let allKeys = Object.keys(item)
                        for (let j = 0; j < allKeys.length; j++) {
                            let key = allKeys[j];
                            let value = item[key];
                            if (key != 'name' && key != 'type') {
                                if (value == undefined || value == null) {
                                    value = "";
                                }
                                tempDataObject[key] = value;
                            }
                        }
                    });
                }
                return tempDataObject;
            },
            cmsRequest: function (config) {
                if (!config) {
                    // this.$alertify.alert("Error", "We have found some technical difficulties. Please contact admin.");
                    return false;
                } else {
                    var AgencyCode = HubServices.Agency_Code;
                    var CMS_SERVER = HubServices.CMS_SERVER;
                    var QUERY_STRING = HubServices.QUERY_STRING;
                    var CMS_METHOD_BASEPATH = HubServices.CMS_METHOD_BASEPATH.replace(/%s/g, AgencyCode);
                    var CMS_TYPE = config.pageType;
                    var PageUrl = config.pageUrl;
                    var url = CMS_SERVER + QUERY_STRING + CMS_METHOD_BASEPATH + CMS_TYPE + PageUrl;

                    config.axiosConfig = {
                        method: "get",
                        url: url,
                    };
                    config.axiosConfig.headers = {
                        'content-type': 'text/html',
                        'Accept': 'text/html',
                        'Accept-Language': config.lang
                    };
                }
                axios(config.axiosConfig)
                    .then(function (response) {
                        // handle success
                        if (response.data) {
                            config.successCallback(response);
                        } else {
                            config.errorCallback("error");
                            console.log("error");
                        }
                    })
                    .catch(function (error) {
                        if (error) {
                            config.errorCallback(error);
                            console.log(error);
                        } else {
                            config.errorCallback("error");
                            console.log('Error', "error");
                        }
                    });
            },
            getDbDataTableValue: async function (extraFilter, sortField) {
                var queryStr = "select * from cms_forms_data where nodeCode = '" + HubServices.Agency_Code + "'";
                if (extraFilter != undefined && extraFilter != '') {
                    queryStr = queryStr + " AND " + extraFilter;
                }
                var requestObject = {
                    query: queryStr,
                    sortField: sortField,
                    from: 0,
                    orderBy: "desc"
                };

                // var  url ="https://cms.oneviewitsolutions.com:9443/cms/data/search/byQuery";
                var url = HubServices.CMS_SERVER + HubServices.Form_Search_ByQuery;
                if (requestObject != null) {
                    requestObject = JSON.stringify(requestObject);
                }
                try {
                    let allDBData = await axios({
                        url: url,
                        method: 'post',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        data: requestObject
                    })
                    return allDBData;
                } catch (error) {
                    return error.response.data.code;
                }
            },
            cmsFormData: async function (data) {
                // var baseUrl = "https://cms.oneviewitsolutions.com:9443/";
                // var urlParam = "cms/data";
                var Agency_Code = HubServices.Agency_Code;
                var url = HubServices.CMS_SERVER + HubServices.CMS_Form;
                var callMethod = "POST";
                if (data != null) {
                    data.nodeCode = Agency_Code;
                    data = JSON.stringify(data);
                }
                try {
                    let formPostRes = await axios({
                        url: url,
                        method: callMethod,
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        data: data
                    })
                    return formPostRes;
                } catch (error) {
                    console.log(error);
                    return error.response.data.code;
                }
            },
            cmsFormUpdateData: async function (data, id) {
                // var baseUrl = "https://cms.oneviewitsolutions.com:9443/";
                // var urlParam = "cms/data";
                var Agency_Code = HubServices.Agency_Code;
                var url = HubServices.CMS_SERVER + HubServices.CMS_Form + "/" + id;
                var callMethod = "PUT";
                if (data != null) {
                    data.nodeCode = Agency_Code;
                    data = JSON.stringify(data);
                }
                try {
                    let formPostRes = await axios({
                        url: url,
                        method: callMethod,
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        data: data
                    })
                    return formPostRes;
                } catch (error) {
                    console.log(error);
                    return error.response.data.code;
                }
            },
            deleteDbDataTableValue: async function (id) {
                // var HubServices = this.HubServicesUrls;
                var url = HubServices.CMS_SERVER + HubServices.CMS_Form + '/' + id;

                try {
                    let allDBData = await axios({
                        url: url,
                        method: 'delete',
                    })
                    return allDBData;
                } catch (error) {
                    return error.response.data.code;
                }
            },
            getUrlData: function () {
                var vars = [],
                    hash;
                var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
                for (var i = 0; i < hashes.length; i++) {
                    hash = hashes[i].split('=');
                    vars[hash[0]] = hash[1];
                }
                return vars;
            },
            sendMail: async function (data) {

                var url = HubServices.Mail_URL;

                if (data != null) {
                    try {
                        let formPostRes = await axios({
                            url: url,
                            method: "POST",
                            headers: {
                                'Content-Type': 'application/json',
                                'Accept': 'application/json'
                            },
                            data: JSON.stringify(data)
                        })
                        return formPostRes;
                    } catch (error) {
                        console.log(error);
                        return error.response.data.code;
                    }
                }

            },
            getValidationMsgByCode: function (code) {
                if (localStorage.validationItems !== undefined) {
                    var validationList = JSON.parse(localStorage.validationItems);
                    for (let validationItem of validationList.Validation_List) {
                        if (code === validationItem.Code) {
                            return validationItem.Message;
                        }
                    }
                }
            },
            getValidationMsgs: function () {
                var self = this;
                var language = localStorage.Language ? localStorage.Language : "en";
                var config = {
                    pageType: "Template/",
                    pageUrl: "20 Validations/20 Validations/20 Validations.ftl",
                    lang: language,

                    successCallback: function (response) {
                        var res = response.data;
                        if (res.area_List) {
                            var validationData = self.pluck("Validation", res.area_List);
                            self.validationList = self.getAllMapData(validationData[0].component);
                            localStorage.setItem('validationItems', JSON.stringify(self.validationList));
                        }
                    },
                    errorCallback: function (error) {
                        console.log(error);
                    }
                };
                this.cmsRequest(config);
            },
            getcurrency: function (config) {
                if (!config) {
                    this.$alertify.alert("Error", "We have found some technical difficulties. Please contact admin.");
                    return false;
                } else {
                    var AgencyCode = HubServices.Agency_Code;
                    var huburl = HubServices.huburl;
                    var portno = HubServices.portno;
                    AgencyCode = AgencyCode.replace("AGY", "");
                    var requrl = config.requrl + AgencyCode;
                    var url = huburl + portno + requrl;
                    config.axiosConfig = {
                        method: "get",
                        url: url,
                    };

                    config.axiosConfig.headers = {
                        'Content-Type': 'application/json'
                    };

                }

                axios(config.axiosConfig)
                    .then(function (response) {
                        // handle success
                        if (response.data) {
                            config.successCallback(response);
                        } else {
                            config.errorCallback("error");
                            console.log("error");
                        }
                    })
                    .catch(function (error) {
                        if (error) {
                            config.errorCallback(error);
                            console.log(error);
                        } else {
                            config.errorCallback("error");
                            console.log('Error', "error");
                        }
                    });
            }
        }
    });
    return myObject;
}